export function chooseAmount() {
  let amountChosen

  const form = document.querySelector('.c-form--funding_wrapper')
  if (form) {
    const formId = form
      .getAttribute('id')
      .split('_')
      .slice(-1)[0]
    const amounts = [...document.querySelectorAll('.c-funding-modal__amount')]
    const amountContainer = document.querySelector('.c-funding-modal__amounts')
    const gformAmountField = document.querySelector(`#input_${formId}_6`)
    amounts.forEach((amount) => {
      amount.addEventListener('click', (e) => {
        amountChosen = e.currentTarget.dataset.amount
        amounts.forEach((a) => {
          if (a !== e.currentTarget) {
            a.classList.add('c-funding-modal__amount--not-selected')
            a.dataset.choice = 'false'
          } else {
            a.classList.remove('c-funding-modal__amount--not-selected')
            gformAmountField.value = e.currentTarget.dataset.amount
            a.dataset.choice = 'true'
          }
        })
      })
    })
  }
}

export function setupPaymentLinks() {
  const recipient = encodeURIComponent('SA NOORED OLÜMPIALE')
  let desc
  let chosenAmount
  let url
  let recipientAccount

  const wrap = document.querySelector('div.c-form__banks')

  const amounts = [...document.querySelectorAll('.c-funding-modal__amount')]
  amounts.forEach((amount) => {
    if (amount.dataset.choice == 'true') {
      chosenAmount = amount.dataset.amount
    }
  })

  wrap.addEventListener('click', (e) => {
    e.preventDefault()
    const bank = e.target.dataset.bank
    const account = e.target.dataset.account
    const desc = encodeURIComponent(e.target.dataset.description)
    switch (bank) {
      case 'seb':
        recipientAccount = account
        url = `https://e.seb.ee/ip/ipank?act=SMARTPAYM&lang=EST&field1=benname&value1=${recipient}&field3=benacc&value3=${recipientAccount}&field10=desc&value10=${desc}&value11=&field5=amount&value5=${chosenAmount}&paymtype=REMSEBEE&field6=currency&value6=EUR`
        break
      case 'lhv':
        recipientAccount = account
        url = `https://www.lhv.ee/portfolio/payment_out.cfm?i_receiver_name=${recipient}&i_receiver_account_no=${recipientAccount}&i_amount=${chosenAmount}&i_payment_desc=${desc}`
        break
      case 'swedbank':
        recipientAccount = account
        url = `https://www.swedbank.ee/private/d2d/payments2/domestic?payment.amount=${chosenAmount}&payment.beneficiaryAccountNumber=${recipientAccount}&payment.beneficiaryName=${recipient}&payment.details=${desc}`
        break
      default:
        break
    }
    if (chosenAmount) {
      window.location = url
    }
  })
}
